module.exports = __webpack_public_path__ + "img/item5-3.b6fe90b0.jpg";